export default __webpack_public_path__ + "static/media/GuyAnimation19.2b9cff42.svg";